import React from "react";
import { Logo } from "./Logo";
import { UserMenu } from "../components/UserMenu";
import { ConfigurationCodeInput } from "../components/ConfigurationCodeInput";
import { LegalLinks } from "../components/LegalLinks";

export function Header() {
  return (
    <header className="header" role="banner" aria-label={I18N("Kopfzeile")}>
      <Logo />

      <h1 className="title">{I18N("MASS TITEL")}</h1>

      {APP.settings.ZeigeChangelog && (
        <a
          className="changelog"
          href="changelog"
          title={I18N("Changelog")}
          aria-label={I18N("Änderungsprotokoll anzeigen")}
        >
          {I18N("Changelog")}
        </a>
      )}

      <aside className="header__right-menue" aria-label={I18N("Links und Benutzeroptionen")}>
        <LegalLinks />
        <ConfigurationCodeInput />
        {APP.settings.ZeigeUserMenu && <UserMenu align="right" />}
      </aside>
    </header>
  );
}
